import { CircularProgress } from '@mui/material';
import { FileUploadState } from './states';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
export const getFileUploadStateIcon = (fileUploadState: FileUploadState) => {
  switch (fileUploadState) {
    case FileUploadState.PROCESSING:
      return (
        <CircularProgress style={{ height: '1.7rem', width: '1.7rem', marginLeft: '.6rem' }} />
      );
    case FileUploadState.COMPLETED:
      return (
        <CheckCircleIcon
          sx={{
            height: '1.7rem',
            width: '1.7rem',
            color: 'success.main',
            ml: '.6rem'
          }}
        />
      );
    case FileUploadState.ERROR:
      return (
        <WarningIcon
          sx={{
            height: '1.7rem',
            width: '1.7rem',
            color: 'warning.main',
            ml: '.6rem'
          }}
        />
      );
      break;
    case FileUploadState.WARNING:
      return (
        <WarningIcon
          sx={{
            height: '1.7rem',
            width: '1.7rem',
            color: 'warning.main',
            ml: '.6rem'
          }}
        />
      );
    default:
      return null;
  }
};
